import { SelectOption } from '../types';

export type TransactionFilters = {
  municipalities: string;
  createdDateRange: {
    startDate: string;
    endDate: string;
  };
  status: string;
};
export type StateProps = {
  label: string;
  status: string;
  value: string;
  _id: string;
};
export type ApproverDetails = {
  isApproved: boolean;
  approvedBy: string;
  approvedDate: string;
  approver: string;
  status: string;
};
export type TitleCompanyType = {
  _id: string;
  name: string;
};
export type TransactionPropTypes = {
  transactionId: string;
};
export type TransactionData = {
  createdBy: string;
  firebaseId: string;
  id: string;
  pendingTasks: number;
  property: any;
  status: string;
  updatedAt: string;
  transactionCode: string;
};

export type PaymentProps = {
  firebaseId: string;
  userEmail: string;
  cost: string;
  costItem: string;
  transactionId: string;
  paymentId: string;
  paymentStatus: boolean;
  paidAmount: number;
  cardHolderName: string;
  cardEnding: number;
  dateofPayment: string;
  cardType: String;
  cardBrand: String;
  _id?: string;
};

export type UserTypeOptions = {
  _id: string;
  profUserTypeId: string;
  value: string;
  label: string;
  type?: string;
  key: string;
  user: UserBriefInfo;
};
export const defaultSelectOption = {
  label: 'Please Select',
  value: '',
};
export const defaultUserOption = {
  type: defaultSelectOption,
  user: defaultSelectOption,
  company: '',
  email: '',
  phone: '',
  name: '',
  new: true,
};
export type SellerBuyerInfo = {
  name?: string;
  email: string;
  phone: string;
  address: string;
  showEntityCheckbox: boolean;
  showRadioButtons: boolean;
  subDetails: {
    contactNameForBusiness?: string;
    BusinessName?: string;
    isEntity: boolean;
    isIndividual: boolean;
  };

  new?: boolean;
};

export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

export type UserBriefInfo = {
  type?: SelectOption;
  user?: SelectOption & any;
  name: string;
  firstName?: string;
  lastName?: string;
  email: string;
  phone?: string;
  address?: string;
  company?: string;
  new?: boolean;
  firebaseId?: string;
};

export type ProUserInfo = {
  company: string;
  email: string;
  emailVerification: { completed: boolean; code: string };
  firebaseId: string;
  firstName: string;
  lastName: string;
  phone: string;
  userType: string;
};

export type PaymentSuccess = {
  show: boolean;
  status: string;
};
export type Property = {
  location: string;
  address: string;
  city: string;
  state: string;
  stateId: string;
  zipCode: string;
  latitude: number;
  longitude: number;
  countyId: string;
};

export type PropertyDetailsProps = {
  type: SelectOption;
  notes: string;
  purchasePrice: any;
  closingDate: string;
  pin: string;
};

export type CheckListAction =
  | 'legalDescription'
  | 'verifyTaxCalculations'
  | 'waterReading'
  | 'inspection'
  | 'additionalQuestions'
  | 'proofofTaxPayment';

export type CheckList = {
  status?: string;
  proUser?: SelectOption;
  email?: string;
};

export type TAssignmentChecklist = {
  legalDescription?: CheckList;
  verifyTaxCalculations?: CheckList;
  waterReading?: CheckList;
  inspection?: CheckList;
  additionalQuestions?: CheckList;
  proofofTaxPayment?: CheckList;
};

export type UserDetails = {
  title?: string;
  name?: string;
  status?: string;
  date?: string;
  email?: string;
  phone?: string;
  address?: string;
  showButton?: boolean;
  createdOn?: string;
  type?: string;
  firebaseId?: string;
  image?: string;
  fileName?: string;
  onClick?: (e: any) => void;
  href?: string;
  subDetails?: { contactNameForBusiness: string };
};

export type TransactionDetails = {
  status: string;
  pendingTasks: string;
};

export type MunicipalityDetails = {
  name: string;
  logo: string;
  waterReadingIst?: string;
  inspInst?: string;
  inspDoc?: string;
  taxProofInst?: string;
};

export type PropertyDetails = {
  type: string;
  address: string;
  zip: string;
  purchasePrice: string;
  closingDate: string;
  notes: string;
  county: string;
};

export type InvolvedInfo = {
  buyers: any[];
  sellers: any[];
  professionalUsers: any[];
  assignmentChecklist: any;
};

export type QuesInfo = {
  answer?: string;
  question?: string;
  serialNo?: number;
  questionId?: string;
  id?: string;
};

export type ActivityLogInfo = {
  transactionId?: string;
  firebaseId: string;
  description: string;
  title?: string;
  item: string;
  date?: string;
  user?: any;
  status?: string;
};

export type TaxCheckListProps = {
  completedAt: string;
  docName: string;
  docSrc: string;
  exemption: any;
  firebaseId: string;
  status: string;
  taxAmount: number;
  verified: boolean;
  userType: string;
  user: any;
};
